// extracted by mini-css-extract-plugin
export default {"ProductTablePopup":"_ProductTablePopup--q9wK9","TriggerButton":"_TriggerButton--GHyvp"};